module.exports = __webpack_public_path__ + "img/ind-sdsf.c964d1fc.png";